var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.25C3.925 14.25 3.825 14.225 3.75 14.175C3.6 14.075 3.5 13.925 3.5 13.75V12.75H2.75C1.925 12.75 1.25 12.075 1.25 11.25V5.75C1.25 4.925 1.925 4.25 2.75 4.25H11.25C12.075 4.25 12.75 4.925 12.75 5.75V11.25C12.75 12.075 12.075 12.75 11.25 12.75H6.775L4.25 14.175C4.175 14.225 4.075 14.25 4 14.25ZM2.75 5.25C2.475 5.25 2.25 5.475 2.25 5.75V11.25C2.25 11.525 2.475 11.75 2.75 11.75H4C4.275 11.75 4.5 11.975 4.5 12.25V12.9L6.4 11.825C6.475 11.775 6.55 11.75 6.65 11.75H11.25C11.525 11.75 11.75 11.525 11.75 11.25V5.75C11.75 5.475 11.525 5.25 11.25 5.25H2.75ZM15.25 8.75V3.25C15.25 2.425 14.575 1.75 13.75 1.75H5.25C4.425 1.75 3.75 2.425 3.75 3.25V3.75H4.75V3.25C4.75 2.975 4.975 2.75 5.25 2.75H13.75C14.025 2.75 14.25 2.975 14.25 3.25V8.75C14.25 9.025 14.025 9.25 13.75 9.25H13.25V10.25H13.75C14.575 10.25 15.25 9.575 15.25 8.75ZM10.75 6.5H3.25V7.5H10.75V6.5ZM10.75 8H3.25V9H10.75V8ZM10.75 9.5H3.25V10.5H10.75V9.5Z",
    fill: "#586068"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerFeedback);
export default __webpack_public_path__ + "static/media/customer-feedback.b430dbd7cf5acf08f2e864bb6049df39.svg";
export { ForwardRef as ReactComponent };